import { render, staticRenderFns } from "./pbc-list.vue?vue&type=template&id=47d7a398&scoped=true"
import script from "./pbc-list.vue?vue&type=script&lang=js"
export * from "./pbc-list.vue?vue&type=script&lang=js"
import style0 from "./pbc-list.vue?vue&type=style&index=0&id=47d7a398&scoped=true&lang=css"
import style1 from "./pbc-list.vue?vue&type=style&index=1&id=47d7a398&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d7a398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d7a398')) {
      api.createRecord('47d7a398', component.options)
    } else {
      api.reload('47d7a398', component.options)
    }
    module.hot.accept("./pbc-list.vue?vue&type=template&id=47d7a398&scoped=true", function () {
      api.rerender('47d7a398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/pbc-list.vue"
export default component.exports